import { Dialog, Transition } from "@headlessui/react";
import { Fragment } from "react";

const DeleteConfirmationModal = ({
  isOpen,
  closeModal,
  handleDelete,
  entityName = "item",
}) => (
  <Transition appear show={isOpen} as={Fragment}>
    <Dialog as="div" className="fixed inset-0 z-[100]" onClose={closeModal}>
      {/* Overlay */}
      <div className="fixed inset-0 transition-opacity" style={{ backgroundColor: "rgba(0,0,0,0.7)", backdropFilter: "blur(4px)" }} />

      <div className="fixed inset-0 overflow-y-auto">
        <div className="flex min-h-full items-center justify-center p-4 text-center">
          <div
            className="w-full max-w-sm transform overflow-hidden p-6 text-left align-middle shadow-2xl transition-all"
            style={{
              backgroundColor: "#13171F",
              border: "1px solid rgba(255,255,255,0.1)",
              borderRadius: "16px",
            }}
          >
            <h3 className="text-lg font-semibold leading-6" style={{ color: "#E7EBEF" }}>
              Confirm Delete
            </h3>
            <div className="mt-3">
              <p className="text-sm" style={{ color: "#94A3B8" }}>
                Are you sure you want to <strong style={{ color: "#E7EBEF" }}>delete {entityName}</strong>?
                This action cannot be undone.
              </p>
            </div>
            <div className="mt-6 flex justify-end gap-3">
              <button
                type="button"
                className="px-4 py-2 rounded-lg text-sm font-medium transition-all duration-200"
                style={{
                  backgroundColor: "rgba(255,255,255,0.06)",
                  border: "1px solid rgba(255,255,255,0.1)",
                  color: "#94A3B8",
                }}
                onMouseEnter={(e) => { e.currentTarget.style.backgroundColor = "rgba(255,255,255,0.1)"; e.currentTarget.style.color = "#E7EBEF"; }}
                onMouseLeave={(e) => { e.currentTarget.style.backgroundColor = "rgba(255,255,255,0.06)"; e.currentTarget.style.color = "#94A3B8"; }}
                onClick={closeModal}
              >
                Cancel
              </button>
              <button
                type="button"
                className="px-4 py-2 rounded-lg text-sm font-semibold transition-all duration-200"
                style={{ backgroundColor: "rgba(239,68,68,0.15)", border: "1px solid rgba(239,68,68,0.3)", color: "#F87171" }}
                onMouseEnter={(e) => { e.currentTarget.style.backgroundColor = "rgba(239,68,68,0.25)"; }}
                onMouseLeave={(e) => { e.currentTarget.style.backgroundColor = "rgba(239,68,68,0.15)"; }}
                onClick={handleDelete}
              >
                Delete
              </button>
            </div>
          </div>
        </div>
      </div>
    </Dialog>
  </Transition>
);

export default DeleteConfirmationModal;
